import React, { useState } from "react";
import "./ProductCard.css";
import ProductPopup from "../ProductPopup/ProductPopup"; // adapte le chemin si besoin
import image_not_found from "../../assets/image_not_found.png";
import { checkImageURL } from "../../utils/validations";
import AddToCartButton from "../AddToCartButton"; // adapte le chemin si besoin
import { getImageSrc } from "utils/imageUtils";
export const ProductCard = ({
  setShowPartnerDialog,
  id,
  name,
  brand,
  variant,
  price,
  description,
  category,
  image,
  imageData,
  inStock,
  ...rest
  
}) => {

  // Debug: Log all image-related props for this product
  /* console.log('[ProductCard] id:', id, 'name:', name, 'brand:', brand, 'variant:', variant);
  console.log('[ProductCard] image:', image);
  console.log('[ProductCard] imageData:', imageData);
  console.log('[ProductCard] rest:', rest);
 */
  // Unified image selection logic (like OrdersManagement)
  let finalImageSrc = image_not_found;
  if (typeof imageData === 'string' && imageData.startsWith('data:image/')) {
    // Base64 data URL
    const base64Data = imageData.split(',')[1] || '';
    if (base64Data.length > 100) {
      finalImageSrc = imageData;
    } else {
      console.warn('[ProductCard][BASE64] Too short or empty for', id, name, 'length:', base64Data.length);
    }
  } else if (typeof imageData === 'string' && (imageData.startsWith('http') || imageData.startsWith('/'))) {
    // Absolute or relative URL
    finalImageSrc = imageData;
  } else if (typeof image === 'string' && image.startsWith('data:image/')) {
    // Fallback to image prop if it's a base64 data URL
    const base64Data = image.split(',')[1] || '';
    if (base64Data.length > 100) {
      finalImageSrc = image;
    } else {
      console.warn('[ProductCard][BASE64] Too short or empty for', id, name, 'length:', base64Data.length);
    }
  } else if (typeof image === 'string' && (image.startsWith('http') || image.startsWith('/'))) {
    finalImageSrc = image;
  } else if (rest && typeof rest.image_url === 'string' && (rest.image_url.startsWith('http') || rest.image_url.startsWith('/'))) {
    finalImageSrc = rest.image_url;
  }

  
  
  

  return (
    <>
  <div className="product-card productCard">
        <div className="imageContainer">
          <img
            src={finalImageSrc}
            className="productImage"
            alt={name?.split(' ')[0]}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = image_not_found;
              console.log('[ProductCard] onError fallback triggered for', name);
            }}
          />
        </div>
        <div className="brand">{brand || name}</div>
        {/* <div className="name">{name}</div> */}
        <div className="variant">{variant}</div>
        <div className="bottomSection">
          <div className="price">
            {Number.isInteger(price) ? price.toString() : price?.toFixed(3)} TND
          </div>
          <AddToCartButton
            style={{ backgroundColor: '#C37559', color: '#fff' }}
            product={{ id, name, description, price, imageData: finalImageSrc, inStock, partner_id: rest.partner_info?.id || rest.partner_id, partner_info: rest.partner_info || {} }}
            disabled={!(inStock === true || inStock === 'true')}
            setShowPartnerDialog={setShowPartnerDialog}
          >
            {inStock === true || inStock === 'true' ? 'Add to Cart' : 'Out of stock'}
          </AddToCartButton>
        </div>
      </div>

      
    </>
  );
};
